// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileExclamationTwoToneSvg from "@fishx/icons-svg/es/asn/FileExclamationTwoTone";
import FishxIcon from '../components/FishxIcon';

var FileExclamationTwoTone = function FileExclamationTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileExclamationTwoToneSvg
  }));
};

FileExclamationTwoTone.displayName = 'FileExclamationTwoTone';
export default React.forwardRef(FileExclamationTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileExclamationTwoTone.js
// module id = 2697
// module chunks = 0